export { ApPrismModule } from './core';
export { ApPrismRxjsModule } from './rxjs';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@angular-package/prism/index.js
// module id = 632
// module chunks = 7